import type { QueryClient } from '@tanstack/react-query';
import { homepageBrowseTagProgressQueryRootKey } from '@/hooks/queries/useHomepageBrowseTagProgressQuery';

const dirtyUserIdsByClient = new WeakMap<QueryClient, Set<string>>();

function dirtyUserIds(queryClient: QueryClient): Set<string> {
  const existing = dirtyUserIdsByClient.get(queryClient);
  if (existing) return existing;

  const created = new Set<string>();
  dirtyUserIdsByClient.set(queryClient, created);
  return created;
}

export function markGameRunCachesDirty(queryClient: QueryClient, userId?: string): void {
  if (!userId) return;
  dirtyUserIds(queryClient).add(userId);
}

export async function reconcileGameRunCaches(
  queryClient: QueryClient,
  userId?: string
): Promise<boolean> {
  if (!userId) return false;

  const dirtyUsers = dirtyUserIds(queryClient);
  if (!dirtyUsers.delete(userId)) return false;

  try {
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: homepageBrowseTagProgressQueryRootKey }),
      queryClient.invalidateQueries({ queryKey: ['userStats', userId] }),
      queryClient.invalidateQueries({ queryKey: ['userTagStats', userId] }),
      queryClient.invalidateQueries({ queryKey: ['userBadges', userId] }),
    ]);
    return true;
  } catch (error) {
    dirtyUsers.add(userId);
    throw error;
  }
}
